import { useCanvasStore } from './canvasStore';
import { useEditorStore } from './editorStore';
import type { CanvasShape } from '../types';

let clipboard: CanvasShape[] | null = null;
let pasteSerial = 0;

function offsetShape(shape: CanvasShape, dx: number, dy: number): CanvasShape {
  return {
    ...shape,
    id: crypto.randomUUID(),
    x: shape.x + dx,
    y: shape.y + dy,
    points: shape.points?.map((value, index) => value + (index % 2 === 0 ? dx : dy)),
  };
}

/** Copy the current selection. Returns false when nothing is selected. */
export function copySelection(): boolean {
  const { selectedIds } = useEditorStore.getState();
  if (!selectedIds.length) return false;
  const picked = useCanvasStore.getState().shapes.filter((shape) => selectedIds.includes(shape.id));
  if (!picked.length) return false;
  clipboard = picked.map((shape) => ({ ...shape }));
  pasteSerial = 0;
  return true;
}

/** Paste a copy of the clipboard, stepped so repeated pastes don't stack. */
export function pasteSelection(): boolean {
  if (!clipboard?.length) return false;
  pasteSerial += 1;
  const step = 28 * pasteSerial;
  const copies = clipboard.map((shape) => offsetShape(shape, step, step));
  const canvas = useCanvasStore.getState();
  copies.forEach((shape) => canvas.addShape(shape));
  canvas.pushHistory();
  useEditorStore.getState().setSelectedIds(copies.map((shape) => shape.id));
  useEditorStore.getState().setActiveTool('select');
  return true;
}
